import { motion, useReducedMotion } from "framer-motion";

export const easeOut = [0.22, 1, 0.36, 1];

const REVEAL_VIEWPORT = { once: true, margin: "0px 0px -8% 0px" };
const REVEAL_SHOW = { opacity: 1, y: 0 };
const MASK_ANIMATE = { y: 0 };

export const fadeUp = {
  hidden: { opacity: 0, y: 42 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: easeOut, delay: i * 0.08 },
  }),
};

export const Reveal = ({ children, className = "", delay = 0, y = 16, as }) => {
  const reduce = useReducedMotion();
  const M = as ? motion[as] : motion.div;
  return (
    <M
      className={className}
      style={{ willChange: "transform, opacity" }}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={REVEAL_SHOW}
      viewport={REVEAL_VIEWPORT}
      transition={{ duration: 0.55, ease: easeOut, delay }}
    >
      {children}
    </M>
  );
};

// masked line reveal — pass an array of strings, each renders on its own line
export const MaskLines = ({ lines, className = "", delay = 0 }) => {
  const reduce = useReducedMotion();
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span
          key={line}
          style={{ display: "block", overflow: "hidden", paddingBottom: "0.06em" }}
        >
          <motion.span
            style={{ display: "block", willChange: "transform" }}
            initial={reduce ? false : { y: "110%" }}
            animate={MASK_ANIMATE}
            transition={{
              duration: 1.05,
              ease: easeOut,
              delay: delay + i * 0.14,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
